"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { ArrowRight, Clock3 } from "lucide-react";
import type { Service } from "@/lib/content-types";

export function ServicesSection({ limit, showAllLink = false }: { limit?: number; showAllLink?: boolean }) {
  const [liveServices, setLiveServices] = useState<Service[]>([]);

  useEffect(() => {
    void fetch("/api/services", { cache: "no-store" }).then((response) => response.ok ? response.json() : null).then((data) => {
      if (Array.isArray(data?.services) && data.services.length) setLiveServices(data.services);
    }).catch(() => undefined);
  }, []);

  const displayedServices = limit ? liveServices.slice(0, limit) : liveServices;

  return (
    <section id="prestations" className="section services-section">
      <div className="container">
        <div className="section-heading split-heading">
          <div><p className="section-label">Prestations</p><h2>Choisir son prochain style</h2></div>
          <p>Les durées sont indicatives. Le tarif exact peut dépendre de la longueur, du modèle et des options choisies.</p>
        </div>
        <div className="service-groups">
          {Array.from(new Set(displayedServices.map((service) => service.category))).map((category, categoryIndex) => (
            <div className="service-group" key={category}>
              <div className="service-group-title"><span>{String(categoryIndex + 1).padStart(2, "0")}</span><h3>{category}</h3></div>
              <div className="service-list">
                {displayedServices.filter((service) => service.category === category).map((service) => (
                  <article className="service-row" key={service.id}>
                    <div><h4>{service.name}</h4><p>{service.description}</p><Link className="service-book-link" href={`/rendez-vous?serviceId=${encodeURIComponent(service.id)}`}>Réserver cette prestation <ArrowRight size={15} /></Link></div>
                    <div className="service-meta"><span><Clock3 size={15} /> {Math.floor(service.durationMinutes / 60)} h{service.durationMinutes % 60 ? ` ${service.durationMinutes % 60}` : ""}</span><strong>{service.priceLabel}</strong></div>
                  </article>
                ))}
              </div>
            </div>
          ))}
        </div>
        {showAllLink && <div className="services-preview-action"><Link className="button button-ghost" href="/prestations">Voir toutes les prestations <ArrowRight size={18} /></Link></div>}
      </div>
    </section>
  );
}
